import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.function.name.js";
//
//
//
//

import E from 'wangeditor';
import i18next from 'i18next';
import config from './config';
import { uploadFn } from 'api/common';
export default {
  model: {
    prop: 'value',
    event: 'update'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'editor'
    },
    menus: {
      type: Array,
      default: function _default() {
        return config.menus;
      }
    },
    showFullScreen: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 200
    },
    actionUrl: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      editor: null,
      isChange: false
    };
  },
  watch: {
    value: function value(val) {
      if (!this.isChange) this.editor.txt.html(val);
      this.isChange = false;
    },
    disable: {
      immediate: true,
      handler: function handler(val) {
        var _this = this;
        this.$nextTick(function () {
          if (val) {
            _this.editor.disable();
          } else {
            _this.editor.enable();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.init();
    this.editor.txt.html(this.value);
    this.$nextTick(function () {
      return _toConsumableArray(document.getElementsByClassName('w-e-toolbar')).forEach(function (el, index) {
        el.style.zIndex = config.zIndex + 10 - index;
      });
    });
  },
  methods: {
    setHtml: function setHtml(val) {
      this.editor.txt.html(val || this.value);
    },
    clearHtml: function clearHtml() {
      this.editor && this.editor.txt.clear();
    },
    init: function init() {
      var _this2 = this;
      this.editor = new E('#' + this.id);
      this.editor.config.height = this.height;
      this.editor.config.menus = this.menus; // 菜单1
      this.editor.config.zIndex = config.zIndex;
      this.editor.config.lang = config.lang; // 语言
      this.editor.config.showFullScreen = this.showFullScreen;
      this.editor.config.languages[config.lang] = config.langTemplate; // 语言包
      this.editor.i18next = i18next;
      this.editor.config.onchangeTimeout = config.changeTimeout; // 延迟
      this.editor.config.uploadImgMaxLength = 1; // 限制一次最多能传几张图片
      this.editor.config.customUploadImg = function (files, fn) {
        var loading = _this2.$loading({
          body: true,
          text: _this2.$t('702')
        });
        var file_name = files[0].name.replace(/\s+/g, '');
        uploadFn(_this2.actionUrl, {
          file_name: file_name,
          type: 'WORK_ORDER'
        }).then(function (res) {
          if (res && res.code === 1) {
            var _res$data = res.data,
              put_url = _res$data.put_url,
              content_type = _res$data.content_type,
              object_url = _res$data.object_url;
            var xhr = new XMLHttpRequest();
            xhr.open('PUT', put_url, true);
            xhr.setRequestHeader('Content-Type', content_type);
            xhr.send(files[0]);
            xhr.onreadystatechange = function () {
              if (xhr.readyState === 4) {
                if (xhr.status === 200 || xhr.status === 304) {
                  loading.close();
                  fn(object_url);
                }
              }
            };
          }
        });
      };
      this.editor.config.onchange = function (newHtml) {
        _this2.isChange = true;
        _this2.$emit('update', newHtml);
      };
      this.editor.create();
    }
  }
};